import axiosInstance from './axios-instance';

export const changeUserPassword = (currentPassword: string, newPassword: string) =>
  axiosInstance.post('user/password;changed', { currentPassword, newPassword });
